import { useTheme } from '@mui/material/styles';

export const useGetDashColor = (
  isDragAccept: boolean,
  isDragReject: boolean
): string => {
  const theme = useTheme();
  if (isDragAccept) {
    return theme.palette.success.main;
  }
  if (isDragReject) {
    return theme.palette.error.main;
  }
  return theme.palette.text.secondary;
};

export const isFileIgnored = (fileName: string) => {
  const ignoredFileNameRegex = /^[.$~]/;
  return ignoredFileNameRegex.test(fileName);
};
